<div class="profile-setting">
    <div class="setting-btn refresh">
        <a href="javascript:void(0)" class="d-flex">
            <app-feather-icon [icons]="'rotate-cw'"
                [class]="'icon icon-theme stroke-width-3 iw-11 ih-11'"></app-feather-icon>
        </a>
    </div>
    <div class="setting-btn setting setting-dropdown" (clickOutside)="outSideClose()">
        <div class="btn-group custom-dropdown arrow-none dropdown-sm">
            <a href="javascript:void(0)" class="d-flex" [class.show]="isShow" (click)="isShow = !isShow">
                <app-feather-icon [icons]="'sun'"
                    [class]="'icon icon-theme stroke-width-3 iw-11 ih-11'"></app-feather-icon>
            </a>
            <div class="dropdown-menu dropdown-menu-right custom-dropdown" [class.show]="isShow"
                style="position: absolute;inset: 0px auto auto 0px;margin: 0px;transform: translate(0px, 13px);">
                <ul>
                    <li>
                        <a href="javascript:void(0)">
                            <app-feather-icon [icons]="'edit'"
                                [class]="'icon-font-light iw-16 ih-16'"></app-feather-icon>edit profile</a>
                    </li>
                    <li>
                        <a href="javascript:void(0)">
                            <app-feather-icon [icons]="'user'"
                                [class]="'icon-font-light iw-16 ih-16'"></app-feather-icon>view profile</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="profile-content">
    <a [routerLink]="['/profile/timeline']" class="image-section">
        <div class="profile-img">
            <div style="background-image: url(assets/images/story/8.jpg);
                background-size: cover;
                background-position: center center;
                background-repeat: no-repeat;
                display: block;">
                <img src="assets/images/story/8.jpg" class="img-fluid  bg-img" alt="profile" style="display: none;">
            </div>
            <span class="stats">
                <img src="assets/images/icon/verified.png" class="img-fluid " alt="verified">
            </span>
        </div>
    </a>
    <div class="profile-detail">
        <a [routerLink]="['/profile/timeline']">
            <h2>kelin jasen <span>❤</span></h2>
        </a>
        <h5>kelin.jasen156&#64;gmail.com</h5>
        <div class="description">
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </p>
        </div>
        <div class="counter-stats">
            <ul id="counter">
                <li>
                    <h3 class="counter-value">546</h3>
                    <h5>following</h5>
                </li>
                <li>
                    <h3 class="counter-value">26335</h3>
                    <h5>likes</h5>
                </li>
                <li>
                    <h3 class="counter-value">6845</h3>
                    <h5>followers</h5>
                </li>
            </ul>
        </div>
        <a href="javascript:void(0)" class="btn btn-solid">view profile</a>
    </div>
</div>